/**
 * Operator-/caregiver-facing display labels for credential + compliance types.
 *
 * Single source of truth (Phase 17 admin-credential-fixes): the caregiver-portal
 * catalog, the operator admin caregiver-detail cards, and any other surface that
 * renders a credential/compliance type all read from HERE, so the raw enum
 * (`TB_TEST`, `CNO_REGISTRATION`, …) never leaks into the UI and the wording can
 * never drift between surfaces. Labels are operator-confirmed (see the DSW / Food
 * Handler notes) and match the operator-runbook terminology.
 */
export const CREDENTIAL_LABELS = {
    NACC: 'NACC certificate',
    CNO_REGISTRATION: 'CNO registration',
    VSC: 'Vulnerable Sector Check (VSC)',
    GOVERNMENT_ID: 'Government-issued ID',
    DSW_CREDENTIAL: 'DSW certificate', // final label confirmed by operator 2026-07-22
    FOOD_HANDLER: 'Food Handler Licence', // Cook / Dietary Aide role-specific cert
    CPR: 'CPR certification', // mandatory for RN / RPN / PSW / DSW (2026-08 revamp)
};
export const COMPLIANCE_LABELS = {
    TB_TEST: 'TB test',
    // The `VACCINATION` compliance type is specifically the COVID-19 vaccination
    // record (the enum value stays `VACCINATION` per the internal-identifier ≠
    // user-facing-label convention, q11 §3b — like VSC / NACC). The label is
    // COVID-specific to avoid confusion with other immunizations.
    VACCINATION: 'COVID-19 vaccination record',
    GENERAL_LIABILITY_INSURANCE: 'General liability insurance',
    WSIB_CLEARANCE: 'WSIB clearance certificate',
};
//# sourceMappingURL=credential-labels.js.map